export default {
      id: "wheel-usage",
      viewBox: "0 0 356.81 356.45",
      url: __webpack_public_path__ + "img/icons.e748fd75.svg#wheel",
      toString: function () {
        return this.url;
      }
    }